import OrganizationTickets from "../../../components/organization/reports/daily/OrganizationTickets";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationTickets = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_tickets}
    title="Organization Tickets"
    helmetTitle="Daily Organization Tickets"
    descriptionKey="Tickets"
    columnDefinitions={TICKET_SUMMARY_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationTickets
        data={data[0]}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationTickets;
